module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "nav-bottom",
    class: {
      "nav-bottom--scrolling": _vm.$store.state.nav, "nav-bottom--notransparent": _vm.$route.path === "/"
    }
  }, [_c('div', {
    staticClass: "nav-bottom__container"
  }, [(_vm.props.acf.virtual_services_button.label && _vm.props.acf.virtual_services_button.href) ? _c('a', {
    staticClass: "nav-bottom__button",
    attrs: {
      "href": _vm.props.acf.virtual_services_button.href
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.virtual_services_button.label)
    }
  }) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67b2b356","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/navigation/nav-bottom/nav-bottom.pug
// module id = 715
// module chunks = 1